/* eslint-disable prettier/prettier */

import axios from "axios";
import cc from "@/js/commonData.js";

export default {
  async checkAdmin() {
    try {
      const response = await axios({
        method: "post",
        url: cc.getDomain() + "/admin/check_admin.php",
        withCredentials: true,
      });

      if (response["data"]["res_status"] == "0") {
        // console.log("관리자 세션 없음");
        // top.location.href = "/alogin";
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error("에러 발생:", error);
      // top.location.href = "/alogin";
      return false;
    }
  },
  async getSessionAdmin() {
    const response = await axios({
      method: "post",
      url: cc.getDomain() + "/admin/check_session.php",
      withCredentials: true,
    });

    // 서버 응답 확인
    // console.log("응답 데이터:", response);

    if (response["data"]["res_status"] == "0") {
      //return { id: "-1" };
      return '{"id":"-1"}';
    }
    return response["data"]["res_userData"];
  },
  async logOut() {
    const response = await axios({
      method: "post",
      url: cc.getDomain() + "/user_logout.php",
      withCredentials: true,
    });

    // 서버 응답 확인
    // console.log("응답 데이터:", response);

    if (response["data"]["res_status"] == "1") {
      // console.log("로그아웃 성공");
    }
  },
};
